import { useRef } from 'react';

import type { SessionLayoutVersion } from '@heidi/analytics';
import { useIsomorphicLayoutEffect } from '@heidi/utils';

import { setSessionLayoutVersion } from './session-layout-registry';

// Re-exported so existing importers and their `jest.mock` literals keep
// resolving here.
export {
  __resetSessionLayoutAnalyticsContextForTests,
  getSessionLayoutVersion,
} from './session-layout-registry';

/**
 * Publishes the layout that SessionPageContent actually committed, after all
 * flag, Labs opt-in, route prerequisites, and loading gates have resolved.
 */
export function useSessionLayoutAnalyticsContext(
  version: SessionLayoutVersion | undefined
): void {
  const ownerRef = useRef<symbol | null>(null);
  if (ownerRef.current === null) {
    ownerRef.current = Symbol('session-layout-analytics-context');
  }
  const owner = ownerRef.current;

  useIsomorphicLayoutEffect(() => {
    setSessionLayoutVersion(owner, version);
    return () => {
      setSessionLayoutVersion(owner, undefined);
    };
  }, [owner, version]);
}
